const SUPER_ADMIN_HASH = process.env.VUE_APP_SUPER_ADMIN_HASH;
const CODE_OK = 'OK';
const CODE_NOK = 'NOK';
const DEFAULT_ERROR_MESSAGE = 'Ha ocurrido un error. Por favor contacte a soporte.';
const FORBIDDEN_ERROR_MESSAGE = 'No cuentas con autorización para realizar esta acción';
const ROLE_BACK_OFFICE = 'ROLE_BACK_OFFICE';
const ROLE_PORTAL = 'ROLE_PORTAL';
const BACK_OFFICE_USER = 'BackOfficeUser';
const PORTAL_USER = 'PortalUser';
const EMAIL_BODY = '<p>Estimado cliente,</p><p>Es un gusto saludarle y notificarle que se han publicado nuevos certificados/informes ' +
    'de servicio en el portal de clientes.<br><br>Puede acceder a ellos a través de los enlaces que se agregan debajo de este texto.' +
/*'o mediante la descarga directa de los archivos adjuntos.*/ '</p><p>Sin más por el momento nos despedimos deseándole un excelente día, saludos.</p>';

const MEMBERSHIP_LEVELS = Object.freeze({
    A: 'A',
    B: 'B',
    C: 'C'
});

const BACK_OFFICE_LOGIN_DOCS = '/docs/backoffice_login/index.html';
const BACK_OFFICE_DOCS = '/docs/backoffice/index.html';
const PORTAL_LOGIN_DOCS = '/docs/portal_login/index.html';
const PORTAL_DOCS = '/docs/portal/index.html';
const SUPER_ADMIN_DOCS = '/docs/super_admin/index.html';

module.exports = {
    CODE_OK,
    CODE_NOK,
    DEFAULT_ERROR_MESSAGE,
    FORBIDDEN_ERROR_MESSAGE,
    ROLE_BACK_OFFICE,
    ROLE_PORTAL,
    BACK_OFFICE_USER,
    PORTAL_USER,
    EMAIL_BODY,
    SUPER_ADMIN_HASH,
    MEMBERSHIP_LEVELS,
    BACK_OFFICE_LOGIN_DOCS,
    BACK_OFFICE_DOCS,
    PORTAL_LOGIN_DOCS,
    PORTAL_DOCS,
    SUPER_ADMIN_DOCS
};